module.exports = __webpack_public_path__ + "img/lobby_hosting_zgw.e4e52fc9.png";